<template>
  <div class="player">
    <video-player ref="videoPlayer" v-show="showPlayer" :options="playerOptions" @ready="() => (showPlayer = true)"></video-player>
  </div>
</template>

<script>
import 'video.js';
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import 'videojs-contrib-hls';
import 'videojs-logo';
import 'videojs-logo/dist/videojs-logo.css';

export default {
  components: { videoPlayer },
  props: ['src'],
  data() {
    return {
      showPlayer: false,
      playerOptions: {
        muted: false,
        aspectRatio: '16:9',
        fluid: true,
        autoplay: true,
        preload: 'auto',
        languages: {
          en: {
            'The media could not be loaded, either because the server or network failed or because the format is not supported.': 'Meeting is not live yet.',
          },
        },
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'application/x-mpegURL',
            src: this.src,
          },
        ],
      },
    };
  },
  mounted() {
    const video_player = this.player;
    const logo = this.isRTL ? '/static/hadaf-logo.svg' : '/static/logo.png';

    video_player.logo({
      image: logo,
      width: 85,
      padding: 10,
      fadeDelay: null,
    });
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
};
</script>
